// extracted by mini-css-extract-plugin
export var sliderRange = "_nl-2";
export var sliderRoot = "_nl-0";
export var sliderThumb = "_nl-3";
export var sliderTrack = "_nl-1";